import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface RequirePasswordChangeGuardProps {
  children: React.ReactNode;
}

export const RequirePasswordChangeGuard: React.FC<RequirePasswordChangeGuardProps> = ({ children }) => {
  const { user, loading, passwordResetRequired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const allowedPaths = [
    '/force-password-change',
    '/reset-password',
    '/auth/clubkeeper-handoff',
  ];

  const isAllowedPath = allowedPaths.some(path => location.pathname === path);

  useEffect(() => {
    if (!loading && user && !isAllowedPath && passwordResetRequired) {
      navigate('/force-password-change', { replace: true });
    }
  }, [user, loading, location.pathname, isAllowedPath, passwordResetRequired, navigate]);

  if (loading) {
    return <>{children}</>;
  }

  if (!user) {
    return <>{children}</>;
  }

  if (passwordResetRequired && !isAllowedPath) {
    return null;
  }

  return <>{children}</>;
};
